import React, { useState } from 'react';
import './ResumeBuilderTab.css';
import ResumeDirectionsSubTab from './ResumeDirectionsSubTab';
import ResumeDirectionGradesSubTab from './ResumeDirectionGradesSubTab';
import TechnologyAreasSubTab from './TechnologyAreasSubTab';
import ResumeParserSubTab from './ResumeParserSubTab';
import ResumeFileLinksSubTab from './ResumeFileLinksSubTab';

function ResumeBuilderTab() {
  const [activeSubTab, setActiveSubTab] = useState('directions');

  return (
    <div className="resume-builder-tab">
      <div className="sub-tabs">
        <button
          className={`sub-tab-button ${activeSubTab === 'directions' ? 'active' : ''}`}
          onClick={() => setActiveSubTab('directions')}
        >
          Направления резюме
        </button>
        <button
          className={`sub-tab-button ${activeSubTab === 'grades' ? 'active' : ''}`}
          onClick={() => setActiveSubTab('grades')}
        >
          Технологии грейдов направлений
        </button>
        <button
          className={`sub-tab-button ${activeSubTab === 'areas' ? 'active' : ''}`}
          onClick={() => setActiveSubTab('areas')}
        >
          Области технологий
        </button>
        <button
          className={`sub-tab-button ${activeSubTab === 'parser' ? 'active' : ''}`}
          onClick={() => setActiveSubTab('parser')}
        >
          Парсинг резюме
        </button>
        <button
          className={`sub-tab-button ${activeSubTab === 'file-links' ? 'active' : ''}`}
          onClick={() => setActiveSubTab('file-links')}
        >
          Ссылки на PDF резюме
        </button>
      </div>
      <div className="sub-tab-content">
        {activeSubTab === 'directions' && <ResumeDirectionsSubTab />}
        {activeSubTab === 'grades' && <ResumeDirectionGradesSubTab />}
        {activeSubTab === 'areas' && <TechnologyAreasSubTab />}
        {activeSubTab === 'parser' && <ResumeParserSubTab />}
        {activeSubTab === 'file-links' && <ResumeFileLinksSubTab />}
      </div>
    </div>
  );
}

export default ResumeBuilderTab;
